import { createReducer } from 'typesafe-actions';
import { projectExportCompleted, projectExportRoutine, resetProjectExport } from './actions.js';

export type ExportState = {
  running: boolean;
  status?: string;
  error?: string;
};

export const initialExportState: ExportState = {
  running: false,
  status: undefined,
  error: undefined
};

export default createReducer<ExportState>(initialExportState)
  .handleAction(
    projectExportRoutine.requested,
    (state: ExportState): ExportState => ({
      ...state,
      running: true,
      status: 'requested'
    })
  )
  .handleAction(
    projectExportRoutine.pending,
    (state: ExportState): ExportState => ({
      ...state,
      running: true,
      status: 'pending'
    })
  )
  .handleAction(
    projectExportRoutine.fulfilled,
    (state: ExportState): ExportState => ({
      ...state,
      running: true,
      status: 'running'
    })
  )
  .handleAction(
    projectExportRoutine.rejected,
    (state: ExportState): ExportState => ({
      ...state,
      running: false,
      status: 'rejected'
    })
  )
  .handleAction(
    projectExportRoutine.cancelled,
    (state: ExportState): ExportState => ({
      ...state,
      running: false,
      status: 'cancelled'
    })
  )
  .handleAction(
    projectExportCompleted,
    (state: ExportState): ExportState => ({
      ...state,
      running: true,
      status: 'completed'
    })
  )
  .handleAction(
    resetProjectExport,
    (state: ExportState): ExportState => ({
      ...state,
      ...initialExportState
    })
  );
